<template>
  <el-table-column :label="label" :prop="prop" class-name="bill-to-code" :sortable="sortable" />
</template>

<script>
export default {
  components: {
  },
  props: {
    label: {
      type: String,
      default: '請求先コード'
    },
    prop: {
      type: String,
      default: 'bill_to_code'
    },
    sortable: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style lang="scss">
.el-table {
  th,
  td {
    &.bill-to-code {
      width: 9.5em;
    }
  }
}
</style>
